import './Footer.css'

const Footer = () => (
  <></>
)

export default Footer
